import {getApiWithoutToken, getApiWithoutTokenAbsoluteURL, postApiWithoutToken} from './api';
import {Action} from '../actionType';
// import {ThreddsServer} from '../../config';

export async function getCascaderOptions(){
        const action = Action.CascaderOptions
        const response = await getApiWithoutToken(action);
        return response;
}

export async function PostChartDataProcess(param){
        const action=Action.ChartDataProcess;
        const response= await postApiWithoutToken(action,param);
        return response;
}

export async function GETLayerInfoStat(param){
        const action=Action.LayerInfoStat;
        const response= await postApiWithoutToken(action,param);
        return response;
}

export async function GETCountryGeojson(){
        const action=Action.GeoServerBaseSmog+'/AirQualityBT/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=AirQualityBT%3Abhutan_country_boundary&maxFeatures=50&outputFormat=application%2Fjson';
        const response= await getApiWithoutTokenAbsoluteURL(action);
        return response;
}
